(function () {

    angular
        .module('smartertoolsApp')
        .controller('accountContactsController', ['$scope', '$timeout', 'accountService', 'notificationFactory', accountContactsController]);

    function accountContactsController($scope, $timeout, accountService, notify) {
        const vm = this;
        vm.contacts = null;
        vm.isSaving = false;
        vm.isDeleting = false;
        vm.countryList = geographicLocations.countries;
        vm.stateList = geographicLocations.statesByCountry;

        // Functions
        vm.attachFocusEvents = attachFocusEvents;
        vm.Reload = Reload;
        vm.viewContact = viewContact;
        vm.addContact = addContact;
        vm.saveContact = saveContact;
        vm.deleteContact = deleteContact;
        vm.doDeleteContact = doDeleteContact;

        activate();

        // -----------------------------------------------

        function activate() {
            Reload();
        }

        function attachFocusEvents() {
            if (!vm.focusEventsAttached) {
                document.getElementById('account-contacts-view').addEventListener('shown.bs.modal', () => { document.getElementById('accountContactFirstName').focus(); });
                vm.focusEventsAttached = true;
            }
        }

        function Reload() {
            $scope.accountCtrl.isLoading++;
            accountService.getAccountSettings()
                .then((data) => {
                    $scope.accountCtrl.isLoading--;
                    vm.contacts = data.Contacts;
                    vm.isPrimaryAccountHolder = data.IsPrimaryAccountHolder;
                    $timeout(() => RecalculateAllFloatLabelControls());
                })
                .catch((err) => {
                    $scope.accountCtrl.isLoading--;
                });

        }

        function viewContact(contact) {
            vm.selectedContact = angular.copy(contact);
            vm.isSaving = false;
            vm.isDeleting = false;
            vm.attachFocusEvents();
            vm.ContactsViewForm.$setPristine();
            vm.ContactsViewForm.$setUntouched();
            bootstrap.Modal.getOrCreateInstance(document.getElementById('account-contacts-view')).show();
            $timeout(() => RecalculateAllFloatLabelControls());
        }

        function addContact() {
            vm.selectedContact = { EmailAlerts: { SummaryInvoice: true, ImportantNotices: true, Invoice: true } };
            vm.isSaving = false;
            vm.isDeleting = false;
            vm.attachFocusEvents();
            vm.ContactsViewForm.$setPristine();
            vm.ContactsViewForm.$setUntouched();
            bootstrap.Modal.getOrCreateInstance(document.getElementById('account-contacts-view')).show();
            $timeout(() => RecalculateAllFloatLabelControls());
        }

        function saveContact() {
            if (vm.ContactsViewForm.$invalid)
                return;
            vm.isSaving = true;
            accountService.saveContact(vm.selectedContact)
                .then(() => {
                    vm.isSaving = false;
                    notify.success('Contact was updated.');
                    bootstrap.Modal.getOrCreateInstance(document.getElementById('account-contacts-view')).hide();
                    vm.Reload();
                })
                .catch(() => {
                    vm.isSaving = false;
                    notify.error('There was a problem updating the item.');
                });
        }

        function deleteContact() {
            if (vm.selectedContact.ContactId)
                vm.isDeleting = true;
        }

        function doDeleteContact() {
            vm.isSaving = true;
            accountService.deleteContact(vm.selectedContact)
                .then(() => {
                    bootstrap.Modal.getOrCreateInstance(document.getElementById('account-contacts-view')).hide();
                    vm.isDeleting = false;
                    vm.isSaving = false;
                    notify.success('Contact was deleted');
                    vm.Reload();
                })
                .catch(() => {
                    vm.isDeleting = false;
                    vm.isSaving = false;
                    notify.error('There was a problem updating the item.');
                });
        }
    }

})();